import React from "react";
import { createRoot } from "react-dom/client";
import OperatorNews from "./OperatorNews";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorNews: unknown;
	}
}

export function renderOperatorNews(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorNews
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorNews = renderOperatorNews;
